import { useAuth } from '../../context/AuthContext';

/**
 * FeatureGate — CAP-008. Mostra i figli solo se il flag è attivo per il tenant.
 *
 * È SOLO cosmesi: nasconde/avvisa nella UI. Il confine di sicurezza è il backend
 * (403 via HasFeature/@richiede_feature) — questo evita solo che l'artigiano veda
 * un bottone che poi darebbe errore.
 *
 * Uso:
 *   <FeatureGate flag="export_cantieri_pdf">{bottone}</FeatureGate>   // off → upsell
 *   <FeatureGate flag="novita_settore" hideWhenOff>{voce}</FeatureGate> // off → niente
 *
 * Nota: `hasFeature` è fail-closed (flag sconosciuto → false) e i flag sono
 * caricati al login; un cambio piano si riflette al prossimo reload (il backend
 * resta comunque l'autorità e rifiuta subito via API).
 */
export default function FeatureGate({ flag, children, hideWhenOff = false, upsellText }) {
  const { hasFeature } = useAuth();

  if (hasFeature(flag)) return <>{children}</>;
  if (hideWhenOff) return null;

  return (
    <div
      role="note"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 12px',
        minHeight: 44,
        boxSizing: 'border-box',
        border: '1px solid var(--border)',
        borderRadius: 8,
        background: 'var(--surface)',
        color: 'var(--muted)',
        fontSize: 13,
        fontWeight: 400,
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
           stroke="#4FAF8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
           aria-hidden="true">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      <span>{upsellText || 'Disponibile in un piano superiore'}</span>
    </div>
  );
}
